import { render, staticRenderFns } from "./ApiKeyDetails.vue?vue&type=template&id=1d2120c5&scoped=true&"
import script from "./ApiKeyDetails.vue?vue&type=script&lang=js&"
export * from "./ApiKeyDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApiKeyDetails.vue?vue&type=style&index=0&id=1d2120c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2120c5",
  null
  
)

export default component.exports